<template>
	<svg :class="{'cognito-ai--thinking': isThinking}" class="cognito-ai h-100" width="286" height="286" viewBox="0 0 286 286" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g filter="url(#body-glow)">
			<path class="spin-1" d="M129.354 41.4982C129.354 41.4982 136.177 40.6997 143 40.6997C149.823 40.6997 156.646 41.4982 156.646 41.4982L162.426 66.2345C170.133 68.161 177.397 71.2076 184.033 75.1912L205.618 61.783C205.618 61.783 211.007 66.0431 215.832 70.8677C220.657 75.6924 224.917 81.0817 224.917 81.0817L211.509 102.667C215.492 109.303 218.539 116.566 220.465 124.273L245.202 130.053C245.202 130.053 246 136.877 246 143.7C246 150.523 245.202 157.346 245.202 157.346L220.465 163.126C218.539 170.833 215.492 178.096 211.509 184.733L224.917 206.318C224.917 206.318 220.657 211.707 215.832 216.532C211.007 221.356 205.618 225.616 205.618 225.616L184.033 212.208C177.397 216.192 170.133 219.238 162.426 221.165L156.646 245.901C156.646 245.901 149.823 246.7 143 246.7C136.177 246.7 129.354 245.901 129.354 245.901L123.574 221.165C115.867 219.238 108.603 216.192 101.967 212.208L80.382 225.616C80.382 225.616 74.9927 221.356 70.168 216.532C65.3434 211.707 61.0833 206.318 61.0833 206.318L74.4915 184.733C70.5079 178.096 67.4613 170.833 65.5348 163.126L40.7984 157.346C40.7984 157.346 40 150.523 40 143.7C40 136.877 40.7985 130.053 40.7985 130.053L65.5348 124.273C67.4613 116.566 70.5078 109.303 74.4914 102.666L61.0833 81.0817C61.0833 81.0817 65.3434 75.6924 70.168 70.8677C74.9927 66.0431 80.382 61.783 80.382 61.783L101.967 75.1912C108.603 71.2076 115.867 68.161 123.574 66.2345L129.354 41.4982Z" fill="#00CAC1" />
		</g>

		<path class="spin-1-cc" d="M107.905 214.678C125.25 223.288 145.151 225.234 163.835 220.146C182.519 215.059 198.687 203.292 209.273 187.077C219.858 170.862 224.125 151.327 221.265 132.175C218.405 113.023 208.617 95.5859 193.756 83.171" stroke="#09A098" stroke-width="9.91645" />
		<path class="spin-1-cc" d="M76.747 91.9948C64.0839 108.188 57.7834 128.455 59.0337 148.974C60.2841 169.492 68.9989 188.844 83.5346 203.38" stroke="#F9CE62" stroke-width="3.5594" />
		<path class="spin-2" d="M87.0726 128.67C83.8838 140.429 84.4782 152.894 88.7714 164.296C93.0646 175.698 100.839 185.458 110.991 192.194C121.144 198.929 133.159 202.297 145.333 201.82C157.507 201.343 169.222 197.045 178.816 189.536" stroke="#FFF7E3" stroke-width="8.36093" stroke-dasharray="1.56 3.89" />
		<path class="spin-3" d="M205.601 158.461C208.83 144.638 207.388 130.134 201.5 117.217C195.613 104.3 185.611 93.6981 173.06 87.0675C160.508 80.4368 146.113 78.1516 132.125 80.5688C118.137 82.9861 105.344 89.9697 95.7459 100.428" stroke="#234652" stroke-width="0.777761" stroke-dasharray="1.56 3.89" />

		<g filter="url(#mouth-glow)" style="mix-blend-mode: screen;" class="cognito-ai__mouth">
			<circle class="cognito-ai__inner-mouth pulse" cx="143" cy="143" r="24" fill="white" />
			<circle class="cognito-ai__outer-mouth pulse-2" cx="143" cy="143" r="24" fill="white" />
		</g>

		<defs>
			<filter id="body-glow" x="0" y="0.699707" width="286" height="286" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
				<feFlood flood-opacity="0" result="BackgroundImageFix" />
				<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
				<feOffset />
				<feGaussianBlur stdDeviation="20" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.792157 0 0 0 0 0.756863 0 0 0 0.75 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_15_90" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15_90" result="shape" />
			</filter>

			<filter id="mouth-glow" x="101.751" y="102.896" width="90" height="90" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
				<feFlood flood-opacity="0" result="BackgroundImageFix" />
				<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
				<feOffset />
				<feGaussianBlur stdDeviation="3.5" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_15_90" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15_90" result="shape" />
			</filter>
		</defs>
	</svg>
</template>

<script>
	export default {
		name: 'CognitoAI',
		props: {
			isThinking: {
				default: false,
				type: Boolean
			}
		}
	};
</script>

<style lang="scss">
	.cognito-ai {
		width: 100%;
		height: 100%;

		* {
			transform-origin: 50% 50%;
		}

		&__outer-mouth {
			opacity: .3;
		}

		.spin-1 {
			animation: spin 150s linear infinite;
		}

		.spin-2 {
			animation: spin 100s linear infinite;
		}

		.spin-3 {
			animation: spin 15s linear infinite;
		}

		.spin-1-cc {
			animation: spin-cc 150s linear infinite;
		}

		.pulse {
			animation: pulse 3s infinite alternate;
		}

		&--thinking {

			.spin-1 {
				animation: spin 5s linear infinite;
			}

			.spin-2 {
				animation: spin 3s linear infinite;
			}

			.spin-3 {
				animation: spin 1.5s linear infinite;
			}

			.spin-1-cc {
				animation: spin-cc 12s linear infinite;
			}

			.pulse {
				animation: pulse .5s infinite alternate;
			}

			.pulse-2 {
				animation: pulse2 .3s infinite alternate;
			}
		}

		@keyframes spin {

			0% {
				transform: rotate(0);
			}

			100% {
				transform: rotate(360deg);
			}
		}

		@keyframes spin-cc {

			0% {
				transform: rotate(0);
			}

			100% {
				transform: rotate(-360deg);
			}
		}

		@keyframes pulse {

			0% {
				transform: scale(1);
			}

			100% {
				transform: scale(1.2);
			}
		}

		@keyframes pulse2 {

			0% {
				opacity: 1;
				transform: scale(1);
			}

			100% {
				opacity: .1;
				transform: scale(1.3);
			}
		}
	}
</style>